// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__wcqVT","inputWrap":"Table_inputWrap__1X8_B","col":"Table_col__2JFOX","bmiTooltip":"Table_bmiTooltip__2htiX"};